import { VehicleCatalogMarket } from '@navio/nsdk';

import { formatCatalogYears } from './catalogYears';

const MARKET_CODES = new Set<string>(Object.values(VehicleCatalogMarket));

const MARKET_SUFFIX = /\s*\[([a-z,\s]+)\]\s*$/i;

/**
 * The provider appends the sales regions to a modification name: `GTI 180 kW [eudm,nadm]`. The regions are
 * a field on the node, so in a label the suffix is the same fact twice -- dropped only when every code
 * in it is a market we know, because anything else is part of the name.
 */
export const catalogNameWithoutMarkets = (name: string): string =>
  name.replace(MARKET_SUFFIX, (suffix: string, regions: string) =>
    regions.split(',').every((region) => MARKET_CODES.has(region.trim().toLowerCase())) ? '' : suffix
  );

/** `Golf (2019–2024)`. The span is dropped when the catalog states neither end. */
export const catalogNodeLabel = (node: { name: string; yearFrom?: number | null; yearTo?: number | null }) => {
  const years = formatCatalogYears(node.yearFrom, node.yearTo);
  return years ? `${node.name} (${years})` : node.name;
};
